import classes from './TextContent.module.css'

function StaticTextContent({ apy, effective_at, min_to_open, balanceToAvoidFees }) {
    return(
        <div className={classes.container}>
          <div className={classes.previewItem}>
            <p>Annual Percentage Yield</p>
            <p className={classes.apyText}>{apy.toFixed(2)}%</p>
            <p>as of {effective_at}</p>
          </div>
          <div className={classes.checkList}>
            <p>Account Type: <strong>Savings</strong></p>
            <p>
              Balance to Open: <strong>${min_to_open}</strong>
            </p>
            <p>
              Balance to Avoid Fees: <strong>${balanceToAvoidFees}</strong>
            </p>
          </div>
        </div>
    )
}

export default StaticTextContent